import { get, find, toUpper } from "lodash";

import * as countries_flags from "./countries_flags.json";

export interface CountryType {
  name: string;
  code: string;
  dial_code: string;
  flag: string;
}

export const countryData: CountryType[] = [
  {
    name: "Argentina",
    code: "AR",
    dial_code: "+54",
    flag: get(countries_flags, "ar", ""),
  },
  {
    name: "Egypt",
    code: "EG",
    dial_code: "+20",
    flag: get(countries_flags, "eg", ""),
  },
  {
    name: "Canada",
    code: "CA",
    dial_code: "+1",
    flag: get(countries_flags, "ca", ""),
  },
  {
    name: "India",
    code: "IN",
    dial_code: "+91",
    flag: get(countries_flags, "in", ""),
  },
  {
    name: "Israel",
    code: "IL",
    dial_code: "+972",
    flag: get(countries_flags, "il", ""),
  },
  {
    name: "United States",
    code: "US",
    dial_code: "+1",
    flag: get(countries_flags, "us", ""),
  },
  {
    name: "United Kingdom",
    code: "GB",
    dial_code: "+44",
    flag: get(countries_flags, "gb", ""),
  },
  {
    name: "France",
    code: "FR",
    dial_code: "+33",
    flag: get(countries_flags, "fr", ""),
  },
  {
    name: "Germany",
    code: "DE",
    dial_code: "+49",
    flag: get(countries_flags, "de", ""),
  },
  {
    name: "Italy",
    code: "IT",
    dial_code: "+39",
    flag: get(countries_flags, "it", ""),
  },
  {
    name: "South Africa",
    code: "ZA",
    dial_code: "+27",
    flag: get(countries_flags, "za", ""),
  },
  {
    name: "Australia",
    code: "AU",
    dial_code: "+61",
    flag: get(countries_flags, "au", ""),
  },
  {
    name: "New zealand",
    code: "NZ",
    dial_code: "+64",
    flag: get(countries_flags, "nz", ""),
  },
  {
    name: "Mexico",
    code: "MX",
    dial_code: "+52",
    flag: get(countries_flags, "mx", ""),
  },
  {
    name: "Brazil",
    code: "BR",
    dial_code: "+55",
    flag: get(countries_flags, "br", ""),
  },
  {
    name: "Russia",
    code: "RU",
    dial_code: "+7",
    flag: get(countries_flags, "ru", ""),
  },
  {
    name: "Ukraine",
    code: "UA",
    dial_code: "+380",
    flag: get(countries_flags, "ua", ""),
  },
  {
    name: "Sweden",
    code: "SE",
    dial_code: "+46",
    flag: get(countries_flags, "se", ""),
  },
  {
    name: "Poland",
    code: "PL",
    dial_code: "+48",
    flag: get(countries_flags, "pl", ""),
  },
  {
    name: "Hungary",
    code: "HU",
    dial_code: "+36",
    flag: get(countries_flags, "hu", ""),
  },
];

export const getDialCode = (countryCode: string): string | undefined =>
  get(find(countryData, { code: toUpper(countryCode) }), "dial_code");

export interface countryDobFormatType {
  [key: string]: string;
}

export enum dobFormat {
  "DD/MM/YYYY" = "DD/MM/YYYY",
  "MM/DD/YYYY" = "MM/DD/YYYY",
  "YYYY/MM/DD" = "YYYY/MM/DD",
}

export const countryDobFormat: countryDobFormatType = {
  GB: "DD/MM/YYYY",
  AU: "DD/MM/YYYY",
  IN: "DD/MM/YYYY",
  DE: "DD/MM/YYYY",
  FR: "DD/MM/YYYY",
  IT: "DD/MM/YYYY",
  ES: "DD/MM/YYYY",
  BR: "DD/MM/YYYY",
  MX: "DD/MM/YYYY",
  RU: "DD/MM/YYYY",
  NL: "DD/MM/YYYY",
  BE: "DD/MM/YYYY",
  NO: "DD/MM/YYYY",
  DK: "DD/MM/YYYY",
  FI: "DD/MM/YYYY",
  CH: "DD/MM/YYYY",
  AT: "DD/MM/YYYY",
  PL: "DD/MM/YYYY",
  GR: "DD/MM/YYYY",
  TR: "DD/MM/YYYY",
  PT: "DD/MM/YYYY",
  IE: "DD/MM/YYYY",
  CZ: "DD/MM/YYYY",
  NZ: "DD/MM/YYYY",
  ZA: "DD/MM/YYYY",
  AR: "DD/MM/YYYY",
  CO: "DD/MM/YYYY",
  CL: "DD/MM/YYYY",
  ID: "DD/MM/YYYY",
  TH: "DD/MM/YYYY",
  VN: "DD/MM/YYYY",
  MY: "DD/MM/YYYY",
  SG: "DD/MM/YYYY",
  EG: "DD/MM/YYYY",
  SA: "DD/MM/YYYY",
  AE: "DD/MM/YYYY",
  IL: "DD/MM/YYYY",
  PK: "DD/MM/YYYY",
  BD: "DD/MM/YYYY",
  NG: "DD/MM/YYYY",
  KE: "DD/MM/YYYY",
  GH: "DD/MM/YYYY",

  US: "MM/DD/YYYY",
  CA: "MM/DD/YYYY",
  PH: "MM/DD/YYYY",

  CN: "YYYY/MM/DD",
  JP: "YYYY/MM/DD",
  KR: "YYYY/MM/DD",
  SE: "YYYY/MM/DD",
  HU: "YYYY/MM/DD",

  DEFAULT: "MM/DD/YYYY",
};

export const countryDobCalenderFormat: Record<string, string> = {
  GB: "dd/MM/yyyy",
  AU: "dd/MM/yyyy",
  IN: "dd/MM/yyyy",
  DE: "dd/MM/yyyy",
  FR: "dd/MM/yyyy",
  IT: "dd/MM/yyyy",
  ES: "dd/MM/yyyy",
  BR: "dd/MM/yyyy",
  MX: "dd/MM/yyyy",
  RU: "dd/MM/yyyy",
  NL: "dd/MM/yyyy",
  BE: "dd/MM/yyyy",
  NO: "dd/MM/yyyy",
  DK: "dd/MM/yyyy",
  FI: "dd/MM/yyyy",
  CH: "dd/MM/yyyy",
  AT: "dd/MM/yyyy",
  PL: "dd/MM/yyyy",
  GR: "dd/MM/yyyy",
  TR: "dd/MM/yyyy",
  PT: "dd/MM/yyyy",
  IE: "dd/MM/yyyy",
  CZ: "dd/MM/yyyy",
  NZ: "dd/MM/yyyy",
  ZA: "dd/MM/yyyy",
  AR: "dd/MM/yyyy",
  CO: "dd/MM/yyyy",
  CL: "dd/MM/yyyy",
  ID: "dd/MM/yyyy",
  TH: "dd/MM/yyyy",
  VN: "dd/MM/yyyy",
  MY: "dd/MM/yyyy",
  SG: "dd/MM/yyyy",
  EG: "dd/MM/yyyy",
  SA: "dd/MM/yyyy",
  AE: "dd/MM/yyyy",
  IL: "dd/MM/yyyy",
  PK: "dd/MM/yyyy",
  BD: "dd/MM/yyyy",
  NG: "dd/MM/yyyy",
  KE: "dd/MM/yyyy",
  GH: "dd/MM/yyyy",

  US: "MM/dd/yyyy",
  CA: "MM/dd/yyyy",
  PH: "MM/dd/yyyy",

  CN: "yyyy/MM/dd",
  JP: "yyyy/MM/dd",
  KR: "yyyy/MM/dd",
  SE: "yyyy/MM/dd",
  HU: "yyyy/MM/dd",

  DEFAULT: "MM/dd/yyyy",
};
